import { baseApi } from "configs/store-query";
import {
  AuthenticationPasswordSignInApiRequest,
  AuthenticationPasswordSignInApiResponse,
  AuthenticationPasswordSignUpApiRequest,
  AuthenticationPasswordSignUpApiResponse,
  AuthenticationPasswordRequestResetApiRequest,
  AuthenticationPasswordRequestResetApiResponse,
  AuthenticationPasswordResendResetApiRequest,
  AuthenticationPasswordResendResetApiResponse,
  AuthenticationPasswordResetApiRequest,
  AuthenticationPasswordResetApiResponse,
} from "apis/authentication/types/authentication-password-api";

const BASE_PATH = "/authentication/password";

export const authenticationPasswordController = baseApi.injectEndpoints({
  endpoints: (build) => ({
    signInPasswordAuthentication: build.mutation<
      AuthenticationPasswordSignInApiResponse,
      AuthenticationPasswordSignInApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/sign-in`,
        method: "POST",
        ...config,
      }),
    }),
    signUpPasswordAuthentication: build.mutation<
      AuthenticationPasswordSignUpApiResponse,
      AuthenticationPasswordSignUpApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/sign-up`,
        method: "POST",
        ...config,
      }),
    }),
    /** Emails a 6-digit password-reset code to the identifier, if it exists. */
    requestResetPasswordAuthentication: build.mutation<
      AuthenticationPasswordRequestResetApiResponse,
      AuthenticationPasswordRequestResetApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/request-reset`,
        method: "POST",
        ...config,
      }),
    }),
    /** Re-sends (rotates) the code for an in-progress password reset. */
    resendResetPasswordAuthentication: build.mutation<
      AuthenticationPasswordResendResetApiResponse,
      AuthenticationPasswordResendResetApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/resend-reset`,
        method: "POST",
        ...config,
      }),
    }),
    /** Completes a password reset with the emailed code and a new password. */
    resetPasswordAuthentication: build.mutation<
      AuthenticationPasswordResetApiResponse,
      AuthenticationPasswordResetApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/reset`,
        method: "POST",
        ...config,
      }),
    }),
  }),
});
